import React, { useEffect, useState } from "react";
import general from "../../../general";
import $ from "jquery";
import { useLockFn, useScroll, useThrottleEffect } from "ahooks";
import dayjs from "dayjs";
import Dialog from "../../../lib/Dialog";
import { NavLink } from "../../../lib/Navigation";

export default (props) => {
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [datas, setDatas] = useState([]);
  const [more, setMore] = useState(true);
  const load = useLockFn(async (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      search_content: props.kw,
      pagination: { count: 20, page: page },
    };
    if (parms.page) {
      tmp.pagination.page = parms.page;
    }
    general.axios
      .post("/v3/user/message/getMessageList", tmp)
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        setInit(true);
        if (parms.page) {
          setPage(parms.page);
        }
        let { message_list: list, paginated } = data;
        setDatas((datas) =>
          parms.page === 1 || !parms.page ? list : [...datas, ...list]
        );
        setMore(paginated.more && list.length > 0);
      })
      .catch((err) => {
        Dialog.error("getMessageList " + err.message);
      });
  });
  useEffect(() => {
    if (props.active && !init) {
      load();
    }
  }, [props.active]);
  useThrottleEffect(() => {
    if (init) {
      $("html,body").scrollTop(0);
      load({ page: 1 });
    }
  }, [props.kw]);

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && init) {
      if (scroll?.top < -80) {
        load({ page: 1 });
      }
      if (
        scroll?.top + window.innerHeight + 20 >= $(document).height() &&
        more
      ) {
        load({ page: page + 1 });
      }
    }
  }, [scroll, props.active]);

  return (
    <div className="message-items">
      {datas.map((data) => (
        <NavLink
          key={data.message_id}
          className={`item ${parseInt(data.read_tag) ? "readed" : ""}`}
          to={`/message?id=${data.message_id}`}
          onClick={() => {
            general.message = data;
          }}
        >
          <div className="info">
            <div className="title">{data.title}</div>
            <div className="time">
              {dayjs.unix(data.message_time).format("YYYY-MM-DD HH:mm:ss")}
            </div>
          </div>
          <div className="content">{data.content}</div>
        </NavLink>
      ))}

      {datas.length > 0 && !more && <div className="pull-to-load nomore"></div>}

      {datas.length === 0 && init && (
        <div
          style={{
            textAlign: "center",
            paddingTop: "30px",
          }}
        >
          <img style={{ width: "60%" }} src="/resources/empty.png" alt="" />
          <p>暂无对应消息</p>
        </div>
      )}
    </div>
  );
};
